import React, { FunctionComponent, ReactNode, } from 'react';
import './AuthLayout.css'

import { ReactComponent as Logo } from  '../../assets/logos/hella-gutmann.svg'

import {
  Card,
  CardContent,
} from '@mui/material';
import { Container } from '@mui/system';
import Footer from '../../components/Footer/Footer';
import Wizard from '../../components/Wizard/Wizard';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store/store';
import { useTranslation } from 'react-i18next';
import { originCleared } from '../../App/app';

interface Props {
  header?: Boolean,
  footer?: Boolean,
  extra?: ReactNode,
  large?: Boolean,
  language?: boolean,
}

const AuthLayout: FunctionComponent<Props> = ( props ) => {

  const header = props.header === true ? true : false;
  const footer = props.footer === false ? false : true;
  const large = props.large === true ? true : false;
  const language = props.language === false ? false : true;


  const origin = useSelector( ( state: RootState ) => state.app.searchParameters.origin );
  const { t } = useTranslation( [ 'wizard' ] );
  const dispatch = useDispatch<AppDispatch>();

  const onBack = () => {
    dispatch( originCleared() );
  }

  return (
    <div className={ `layout auth-layout ${ large ? 'auth-layout-large' : '' }`}>
      <Wizard
        origin={ origin }
        onBack={ onBack }
      ></Wizard>
      <main>
        { header ?<div className="auth-layout__logo">
          <Logo />
        </div> : null }
        { /* Overflow for card is visible because of sticky button on FAQ page */ }
        <Card sx={{ overflow: 'visible' }}>
          <CardContent>
            {props.children}
          </CardContent>
        </Card>
        { props.extra && <Card sx={{ mt: 4, bgcolor: '#03723d', color: 'white',  }}>
          <CardContent>
            { props.extra }
          </CardContent>
        </Card>}
      </main>
      { footer && <Footer language={language} /> }
    </div>
  );
}

export default AuthLayout;
